require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-michele-arnaboldi.json") })
        }
      }, "path---interviste-michele-arnaboldi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-michele-arnaboldi!./.cache/json/interviste-michele-arnaboldi.json
// module id = 684
// module chunks = 231608221292675